import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { variables } from '@starbucks-web/pattern-library/lib/shared-variables';
import { configImagesUrlSelector } from '../../state/selectors/config';

const iconProperties = {
  width: 48,
  height: 59,
  anchorX: 24,
  anchorY: 45,
};
const selectedIcon = Object.assign({}, iconProperties, {
  imagePath: 'location-marker.svg',
});
const highlightedIcon = Object.assign({}, iconProperties, {
  imagePath: 'card-hover-pin.svg',
});
const iconZIndices = {
  default: 10,
  selected: 11,
  highlighted: 12,
};

export class LocatorMarker extends Component {
  constructor(props) {
    super(props);

    this.handleMarkerClick = this.handleMarkerClick.bind(this);

    this.state = { instance: this.createMarker(props) };
  }

  handleMarkerClick() {
    this.props.selectLocation(this.props.locationNumber);
  }

  createMarker(props = this.props) {
    const {
      grayedOut,
      mapInstance,
      position,
      selectable,
      selected,
      storeName,
    } = props;
    const { LatLng } = google.maps;

    const markerPosition = new LatLng(position.latitude, position.longitude);

    const markerOptions = {
      map: mapInstance,
      position: markerPosition,
      zIndex: iconZIndices[selected ? 'selected' : 'default'],
      title: storeName,
    };

    const marker = new google.maps.marker.AdvancedMarkerElement(markerOptions);

    if (selectable) {
      google.maps.event.addListener(marker, 'click', this.handleMarkerClick);
    }

    this.setIcon(marker, { grayedOut, selectable, selected });

    return marker;
  }

  componentWillUnmount() {
    const { instance } = this.state;

    if (instance) {
      instance.map = null;
    }
  }

  componentDidUpdate(prevProps) {
    const { props } = this;

    if (
      props.selected !== prevProps.selected ||
      props.highlighted !== prevProps.highlighted
    ) {
      this.updateIcon({
        grayedOut: props.grayedOut,
        selectable: props.selectable,
        selected: props.selected,
        highlighted: props.highlighted,
      });
    }
  }

  setIcon(markerInstance, iconType) {
    if (iconType?.selected) {
      return this.setSelectedIcon(markerInstance);
    } else if (iconType?.highlighted) {
      return this.setHighlightedIcon(markerInstance);
    }
    return this.setDefaultIcon(markerInstance, iconType);
  }

  setDefaultIcon(markerInstance, { grayedOut, selectable }) {
    const markerIconColor = variables.colorGreenAccent;
    const disabledMarkerIconColor = variables.colorBlack50;
    const circleIcon = document.createElement('div');
    circleIcon.setAttribute(
      'style',
      `border-radius: 50%; 
      border: 1px solid white;
      width: 15px;
      height: 15px;
      background: ${grayedOut || !selectable ? disabledMarkerIconColor : markerIconColor}
    `
    );

    if (markerInstance) {
      markerInstance.content = circleIcon;
    }
  }

  composeSVGIcon(markerInstance, svgInfo) {
    const { imagesUrl } = this.props;
    const markerImage = document.createElement('img');
    markerImage.role = 'presentation';
    markerImage.width = svgInfo.width;
    markerImage.height = svgInfo.height;
    markerImage.src = `${imagesUrl}/${svgInfo.imagePath}`;

    markerInstance.content = markerImage;
  }

  setHighlightedIcon(markerInstance) {
    return this.composeSVGIcon(markerInstance, highlightedIcon);
  }

  setSelectedIcon(markerInstance) {
    return this.composeSVGIcon(markerInstance, selectedIcon);
  }

  updateIcon(iconType) {
    const { instance } = this.state;
    if (!instance) {
      return;
    }

    let zIndex = iconZIndices.default;

    if (iconType.selected) {
      zIndex = iconZIndices.selected;
    } else if (iconType.highlighted) {
      zIndex = iconZIndices.highlighted;
    }

    this.setIcon(instance, iconType);
    instance.zIndex = zIndex;
  }

  render() {
    return null;
  }
}

LocatorMarker.propTypes = {
  grayedOut: PropTypes.bool,
  highlighted: PropTypes.bool,
  locationNumber: PropTypes.string.isRequired,
  mapInstance: PropTypes.object.isRequired,
  position: PropTypes.object.isRequired,
  selectable: PropTypes.bool,
  selected: PropTypes.bool,
  selectLocation: PropTypes.func.isRequired,
  storeName: PropTypes.string.isRequired,
};

LocatorMarker.defaultProps = {
  grayedOut: false,
  highlighted: false,
  selectable: true,
  selected: false,
};

const select = (state) => ({
  imagesUrl: configImagesUrlSelector(state),
});

export default connect(select)(LocatorMarker);
